module.exports = __webpack_public_path__ + "static/media/noun-airplane-1028372-142350.821a1377.svg";